"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUser = exports.sign_up_thunk = exports.update_details_thunk = exports.sign_out_thunk = exports.sign_in_thunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var sign_in_1 = require("../../api/calls/user/sign_in");
var sign_up_1 = require("../../api/calls/user/sign_up");
var main_1 = require("./main");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var _devMode = process.env.NODE_ENV !== "production";
// const userActions = createExtraActions();
// const extraReducers = createExtraReducers();
var initialState = {
    user: {
        user: {
            _id: undefined,
            email: _devMode ? "fred@doshex.com" : "",
            password: _devMode ? "1234" : "",
            confirm_password: undefined,
            name: undefined,
            surname: undefined,
            reset_password_otp: undefined,
            client_id: undefined,
            remember_me: true,
        },
        token: "",
        is_loading: false,
        // is_saving: false,
    },
};
var sign_in_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_in_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie, state, user, response, obj;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cookie = new universal_cookie_1.default();
                    state = getState();
                    user = state.userState.user;
                    return [4 /*yield*/, (0, sign_in_1.sign_in)({
                            email: user.user.email,
                            password: user.user.password,
                        })];
                case 1:
                    response = _b.sent();
                    // console.log("user/sign_in_thunk", response);
                    if (response.success) {
                        obj = __assign(__assign({}, user), response.content);
                        if (user.user.remember_me) {
                            cookie.set("user_state", obj, {
                                sameSite: true,
                            });
                        }
                        dispatch((0, exports.setUser)(obj));
                        dispatch((0, main_1.setDrawerOpen)(false));
                    }
                    else {
                        dispatch((0, main_1.setMainModal)({ title: "Something went wrong!", messages: [response.message] }));
                    }
                    return [2 /*return*/, response];
            }
        });
    });
});
exports.sign_in_thunk = sign_in_thunk;
var sign_out_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_out_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie;
        return __generator(this, function (_b) {
            cookie = new universal_cookie_1.default();
            cookie.remove("user_state");
            // Unset the state.
            dispatch((0, exports.setUser)({
                user: {
                    _id: undefined,
                    email: "",
                    password: "",
                    name: undefined,
                    surname: undefined,
                },
                token: "",
                is_loading: false,
            }));
            //Close the drawer.
            dispatch((0, main_1.setDrawerOpen)(false));
            return [2 /*return*/];
        });
    });
});
exports.sign_out_thunk = sign_out_thunk;
var update_details_thunk = (0, toolkit_1.createAsyncThunk)("user/update_details_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var name, surname, email, phoneNumber, cookie, state, user, newUserObj;
        return __generator(this, function (_b) {
            name = arg.name, surname = arg.surname, email = arg.email, phoneNumber = arg.phoneNumber;
            cookie = new universal_cookie_1.default();
            state = getState();
            user = state.userState.user;
            newUserObj = __assign(__assign({}, user), { user: __assign(__assign({}, user.user), { name: name, surname: surname, email: email, cell_number: phoneNumber }) });
            // If cookie was saved before, update it.
            if (cookie.get("user_state")) {
                cookie.set("user_state", newUserObj, {
                    sameSite: true,
                });
            }
            // Update the state.
            dispatch((0, exports.setUser)(newUserObj));
            return [2 /*return*/];
        });
    });
});
exports.update_details_thunk = update_details_thunk;
// const update_password_thunk = createAsyncThunk(
//   "user/update_password_thunk",
//   async (arg: { newPassword: string; currentPassword: string }, { dispatch, getState }) => {
//     const { newPassword, currentPassword } = arg;
//     // Delete the user cookie.
//     const cookie = new Cookie();
//     update_password({
//       current_password: currentPassword,
//       new_password: newPassword,
//     }).then((response) => {
//       // setIsSaving(false);
//       if (response.success) {
//         // setIsEditing(false);
//         // Update the state.
//         dispatch(setUser(response.content));
//         // If cookie was saved before, update it.
//         if (cookie.get("user_state")) {
//           cookie.set("user_state", response.content, {
//             sameSite: true,
//           });
//         }
//       } else {
//         dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
//       }
//     });
//   }
// );
var sign_up_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_up_thunk", function (arg, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var cookie, state, user, response, obj;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    cookie = new universal_cookie_1.default();
                    state = getState();
                    user = state.userState.user;
                    return [4 /*yield*/, (0, sign_up_1.sign_up)({
                            name: (_b = user.user.name) !== null && _b !== void 0 ? _b : "",
                            surname: (_c = user.user.surname) !== null && _c !== void 0 ? _c : "",
                            email: (_d = user.user.email) !== null && _d !== void 0 ? _d : "",
                            cell_number: (_e = user.user.cell_number) !== null && _e !== void 0 ? _e : "",
                            password: (_f = user.user.password) !== null && _f !== void 0 ? _f : "",
                            birthday: (_g = user.user.birthday) !== null && _g !== void 0 ? _g : new Date(),
                            get_communication: (_h = user.user.get_communication) !== null && _h !== void 0 ? _h : false,
                            agrees_terms_and_conditions: (_j = user.user.agrees_terms_and_conditions) !== null && _j !== void 0 ? _j : false,
                        })];
                case 1:
                    response = _k.sent();
                    // console.log("user/sign_up_thunk", response);
                    if (response.success) {
                        obj = __assign(__assign({}, user), response.content);
                        cookie.set("user_state", obj, {
                            sameSite: true,
                        });
                        dispatch((0, exports.setUser)(obj));
                        dispatch((0, main_1.setDrawerOpen)(false));
                    }
                    else {
                        dispatch((0, main_1.setMainModal)({ title: "Something went wrong!", messages: [response.message] }));
                    }
                    return [2 /*return*/, response];
            }
        });
    });
});
exports.sign_up_thunk = sign_up_thunk;
var slice = (0, toolkit_1.createSlice)({
    name: "user",
    initialState: initialState,
    reducers: {
        setUser: function (state, action) {
            state.user = action.payload;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(sign_in_thunk.fulfilled, function (state, action) {
            // console.log("sign_in_thunk.fulfilled", action);
            state.user.is_loading = false;
        })
            .addCase(sign_in_thunk.rejected, function (state, action) {
            // console.log("sign_in_thunk.rejected", action);
            state.user.is_loading = false;
        })
            .addCase(sign_in_thunk.pending, function (state, action) {
            // console.log("sign_in_thunk.pending", action);
            state.user.is_loading = true;
        })
            .addCase(sign_up_thunk.fulfilled, function (state, action) {
            // console.log("sign_up_thunk.fulfilled", action);
            state.user.is_loading = false;
        })
            .addCase(sign_up_thunk.rejected, function (state, action) {
            // console.log("sign_up_thunk.rejected", action);
            state.user.is_loading = false;
        })
            .addCase(sign_up_thunk.pending, function (state, action) {
            // console.log("sign_up_thunk.pending", action);
            state.user.is_loading = true;
        });
        // .addCase(update_password_thunk.fulfilled, (state, action) => {
        //   // console.log("update_password_thunk.fulfilled", action);
        //   state.user.is_saving = false;
        // })
        // .addCase(update_password_thunk.rejected, (state, action) => {
        //   // console.log("update_password_thunk.rejected", action);
        //   state.user.is_saving = false;
        // })
        // .addCase(update_password_thunk.pending, (state, action) => {
        //   // console.log("update_password_thunk.pending", action);
        //   state.user.is_saving = true;
        // });
    },
});
exports.setUser = slice.actions.setUser;
exports.default = slice.reducer;
